import type { HTMLAttributes } from 'react';

interface CourseProgressBarProps {
  percentage: number;
  label?: string;
  className?: string;
  barClassName?: string;
}

const accessibilityProps = (
  label: string | undefined,
  percentage: number,
): HTMLAttributes<HTMLDivElement> =>
  label
    ? {
        role: 'progressbar',
        'aria-label': label,
        'aria-valuenow': percentage,
        'aria-valuemin': 0,
        'aria-valuemax': 100,
      }
    : { 'aria-hidden': true };

export const CourseProgressBar = ({
  percentage,
  label,
  className = 'h-2 bg-[var(--color-surface-3)]',
  barClassName = 'bg-[var(--color-accent)]',
}: CourseProgressBarProps) => {
  const rounded = Math.round(percentage);

  return (
    <div
      {...accessibilityProps(label, rounded)}
      className={`w-full overflow-hidden rounded-full ${className}`}
    >
      <div
        className={`h-full rounded-full transition-all duration-300 ${barClassName}`}
        style={{ width: `${rounded}%` }}
      />
    </div>
  );
};
